import { operatorEvents } from "@/operator/events/operatorEvents";

export abstract class BaseController<T = object> {
    protected $view: JQuery;

    constructor(cssClass?: string) {
        this.$view = $('<div class="view' + (cssClass !== undefined ? " " + cssClass : "") + '" />').data("ctrl", this);
    }

    public show(transition?: ViewTransition, param?: T) {
        // hide shown vue views
        operatorEvents.hideVisibleVueView.dispatch();

        //hide other controllers
        const activeCtrls = this.$view.parent().find("> .view.shown:not(#vue-app)");
        if (activeCtrls.length > 0) {
            if (activeCtrls.is(this.$view)) return;

            //remove all transitions
            activeCtrls.addClass("notransition shown").removeClass("animleft animright fadetransition fadeout")[0]
                .offsetHeight;

            if (transition !== undefined && transition === ViewTransition.SlideLeft)
                activeCtrls.removeClass("notransition shown").addClass("animleft");
            else if (transition !== undefined && transition === ViewTransition.SlideRight)
                activeCtrls.removeClass("notransition shown").addClass("animright");
            else if (transition !== undefined && transition === ViewTransition.Fade) {
                activeCtrls.addClass("fadetransition")[0].offsetHeight;
                activeCtrls.removeClass("notransition shown").addClass("fadeout");
            } else activeCtrls.removeClass("shown");

            activeCtrls.data("ctrl").onBecomeInvisible();
        }

        //remove all transitions
        this.$view.addClass("notransition").removeClass("animleft shown animright fadetransition fadeout");

        if (transition !== undefined && transition === ViewTransition.SlideLeft) {
            this.$view.addClass("animright")[0].offsetHeight;
            this.$view.removeClass("notransition animright").addClass("shown");
        } else if (transition !== undefined && transition === ViewTransition.SlideRight) {
            this.$view.addClass("animleft")[0].offsetHeight;
            this.$view.removeClass("notransition animleft").addClass("shown");
        } else if (transition !== undefined && transition === ViewTransition.Fade) {
            this.$view.addClass("fadetransition fadeout")[0].offsetHeight;
            this.$view.removeClass("notransition fadeout").addClass("shown");
        } else {
            this.$view.addClass("shown");
        }

        this.onBecomeVisible(param);
    }

    public stackTo($container: JQuery) {
        this.$view.appendTo($container);
    }

    public isVisible(): boolean {
        return this.$view.hasClass("shown");
    }

    public static getActiveCtrl($container: JQuery): BaseController | undefined {
        const active = $container.find("> .shown");
        if (active.length === 0) return undefined;

        if (active.length > 1) return active.last().data("ctrl");

        return active.data("ctrl");
    }

    protected abstract onBecomeVisible(param?: T);
    protected abstract onBecomeInvisible();
}

export enum ViewTransition {
    SlideLeft,
    SlideRight,
    Fade,
}
